import React from 'react';
import { PrivatePageLayout, PageHeader } from '../../components/PrivatePage';
import BacktestForm from './BacktestForm';
import '../../components/PrivatePage/private-page.css';

function Backtest() {
    return (
        <PrivatePageLayout>
            <PageHeader
                eyebrow="Analysis"
                title="Backtest"
                subtitle="Simulate your saved bots and automations against historical data."
            />
            <BacktestForm />
        </PrivatePageLayout>
    );
}

export default Backtest;